import { ClaimItemState } from './claim-item.types';
import {
  ClaimItemActionTypes,
  PREVIEW_CLAIM_ITEM_UPDATE_API_SUCCESS,
  CLEAR_CLAIM_ITEM_PREVIEW,
  INTERNAL_UPDATE_CLAIM_ITEM_API_SUCCESS,
  INTERNAL_UPDATE_CLAIM_ITEM_API_REQUESTED,
} from './claim-item.actions';

const initialState: ClaimItemState = {};

export default (state = initialState, action: ClaimItemActionTypes): ClaimItemState => {
  switch (action.type) {
    case PREVIEW_CLAIM_ITEM_UPDATE_API_SUCCESS:
      return { ...state, pendingInternalUpdate: action.payload };

    case CLEAR_CLAIM_ITEM_PREVIEW:
    case INTERNAL_UPDATE_CLAIM_ITEM_API_REQUESTED:
    case INTERNAL_UPDATE_CLAIM_ITEM_API_SUCCESS:
      return { ...state, pendingInternalUpdate: undefined };

    default:
      return state;
  }
};
